import { useEffect, useState } from 'react'

/** Below Radix's `sm` breakpoint — the width at which the manager tables stop fitting. */
const MOBILE_QUERY = '(max-width: 767px)'

/**
 * Viewport, not user-agent. What decides whether a table fits is how wide the
 * window is, and the two disagree constantly: an iPad in landscape has room for
 * a table, a desktop browser at half-width doesn't, and rotating a phone changes
 * one and not the other. This also re-evaluates on rotate and resize, which a
 * server-rendered guess never could.
 */
export default function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches
  )

  useEffect(() => {
    const query = window.matchMedia(MOBILE_QUERY)
    const onChange = (event: MediaQueryListEvent) => setIsMobile(event.matches)

    setIsMobile(query.matches)
    query.addEventListener('change', onChange)
    return () => query.removeEventListener('change', onChange)
  }, [])

  return isMobile
}
